import type { ReactNode } from 'react';

import { Logo } from '../../atoms/Logo';

type AuthContainerProps = {
  children: ReactNode;
  footer?: ReactNode;
};

const AuthContainer = ({ children, footer }: AuthContainerProps) => (
  <div
    className={
      'flex flex-col h-full w-full items-center justify-center bg-brand'
    }
  >
    <div className={'w-full max-w-[420px] p-4'}>
      <div
        className={
          'flex text-center pb-4 mx-4 items-center justify-center gap-2'
        }
      >
        <Logo />
      </div>
      <div
        className={'p-6 rounded-md border border-gray-300 bg-white shadow-md'}
      >
        {children}
      </div>
      {footer}
    </div>
  </div>
);

export { AuthContainer };
export type { AuthContainerProps };
